import React from "react";
import { connect } from "react-redux";
import dummyImage from "../../../../assets/images/dummyPerson.jpg";
import './onlineUsersList.css'

// function usersList(users){
class UsersList extends React.Component {
  constructor(props) {
    super(props);
    this.hideShowList = this.hideShowList.bind(this)
    this.state = {
        showList: true
    }
  }
  hideShowList(){
    this.setState({showList: !this.state.showList})
  }
  render() {
    console.log('UsersList', this.props.users);
    let userListObjects;
    if(!this.props.users){
        userListObjects = '';
    } else{
      userListObjects = this.props.users.map((obj) => {
        return (
          <li className="list-item" key={obj.login}>
            <div className="profile-container">
              <img
                className="img-circle profilePic list-item-image"
                src={obj.profilePicture ? obj.profilePicture : dummyImage}
              />
              {obj.answerSubmitted && <div className="badge b-success">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z"/>
                      <path d="M20.285 6.707L10 17.99 5.715 13.706 7.127 12.293l3.573 3.573L18.571 7.7z"/>
                  </svg>
              </div>}
              {!obj.answerSubmitted && <div className="badge b-waiting">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z"/>
                      <path d="M12 2a10 10 0 0 0-10 10h2a8 8 0 1 1 8 8v2a10 10 0 0 0 0-20z"/>
                  </svg>
              </div>}
            </div>
            <div className="list-item-content">
              <h4>{obj.name}</h4>
              <p>{obj.login}</p>
            </div>
          </li>
        );
      });
    }
    return (
      <div
        className="online-list-wrapper"
      >
        <div className={this.state.showList ? "heading": "heading rounded"} onClick={this.hideShowList}>
            Online Students ({userListObjects.length})
            <i className="fa fa-times closebutton" ></i>
        </div>
        {this.state.showList && <ul className="list">
          {userListObjects}
        </ul>}
      </div>
    );
  }
}

function mapStateToProps(state) {
    return { ...state };
}

export default connect(mapStateToProps)(UsersList);

